import React, { useState } from 'react';
/**
 * `WhyTabs` renders a tabbed "Why" section for renewal landing pages.
 *
 * Behaviour:
 * - Builds a `TabLink` for each CMS list header.
 * - Maintains internal selected tab id state (defaults to the first tab).
 * - Renders a corresponding `WhyTabPanel` for each CMS list.
 */

import './LandingPage.scss';
import { WhySectionListCustomisation } from '../../../common/CommonTypes';
import TabLink from '../../../common/TabLink/TabLink';
import Tabs from '../../../common/Tabs/Tabs';
import WhyTabPanel from './WhyTabPanel';

export type WhyTabsProps = {
  cms: WhySectionListCustomisation[];
};

const WhyTabs = ({ cms }: WhyTabsProps): JSX.Element => {
  const [tabSelected, setTabSelected] = useState('why-header-0');

  const handleTabSelect = (tabId: string) => {
    setTabSelected(tabId);
  };

  const getId = (i: number): string => {
    return `why-header-${i}`;
  };

  const getTabLinks = () => {
    if (cms && cms.length > 0) {
      return cms.map((item: WhySectionListCustomisation, i) => (
        <TabLink
          id={getId(i)}
          key={i}
          title={item.whySectionListHeader}
          onSelect={handleTabSelect}
          selectedTab={tabSelected}
          selectedStyle='selected-border-color cms-default-underline-colour'
        />
      ));
    }
  };

  const getTabPanels = () => {
    if (cms && cms.length > 0) {
      return cms.map((item: WhySectionListCustomisation, i) => {
        return (
          <WhyTabPanel
            key={i.toString()}
            index={i}
            item={item}
            tabSelected={tabSelected}
          />
        );
      });
    }
  };

  return (
    <Tabs>
      <div className='flex-column why--tabs m4-bottom'>
        <div role='tablist' className='m4-bottom lp-why-section-tabs'>
          {getTabLinks()}
        </div>
        {getTabPanels()}
      </div>
    </Tabs>
  );
};

export default WhyTabs;
